// Central author bio. Edit once, propagates everywhere.
export const AUTHOR = {
    name: "Flying Fitz",
    fullName: "Flying Fitz",
    role: "Founder & Builder",
    location: "St. John's, Newfoundland, Canada",
    credentials: "26-year veteran of the open web. Graduated SNS Training College in 2000.",
    bio: "Flying Fitz has been building websites, apps, and online businesses since 2000 — from raw HTML and PHP days through modern React. He picked up web development at SNS Training College in St. John's, Newfoundland, and never looked back. He's spent his career obsessed with what makes software actually useful: real performance, organic SEO, paid SEO, design, content, and shipping things that real people use. OpenCSV is the kind of tiny, lovable tool he wishes someone had built years ago — so he built it.",
    photo: "/fitz.jpg?v=2",
    photoSmall: "/fitz-sm.jpg?v=2",
    site: "https://opencsv.io",
};

export default AUTHOR;
